import axiosInstance from '../routes/axios-instance';
import handlerError from '../routes/error-handler';
import RoutesAPI from '../routes/api.routes';

export const EntityModel = {
  type_id: 0,
  order: 1,
  label: '',
  value: '',
};

export const LawModel = {
  id: 0,
  name: '',
  last_update: '',
  entities: [
    { ...EntityModel },
  ],
  categoryId: 0,
};

export const EntityTypeModel = {
  id: 0,
  label: '',
};

export default {
  namespaced: true,
  state: {
    law: { ...LawModel },
    laws: [
      { ...EntityModel },
    ],
    entityTypes: [{ ...EntityTypeModel }],
  },
  mutations: {
    add(state, element) {
      state.laws.push(element);
    },
    editOne(state, element) {
      state.law = element;
    },
    editAll(state, laws) {
      state.laws = laws;
    },
    editAllEntityTypes(state, entityTypes) {
      state.entityTypes = entityTypes;
    },
    update(state, element) {
      state.laws = state.laws.map(
        (value) => (element.id === value.id ? element : value),
      );
    },
    delete(state, id) {
      state.laws = state.laws.filter((element) => element.id !== id);
    },
  },
  actions: {
    async getLaw({ commit }, { appId, lawId }) {
      axiosInstance.get(`${RoutesAPI.GET_ALL_APPS}/${appId}/${RoutesAPI.LAWS_PATH}/${lawId}`)
        .then((response) => {
          if (response.data.error) {
            handlerError(response.data.error);
          } else {
            commit('editOne', response.data);
          }
        })
        .catch(handlerError);
    },
    async getLaws({ commit }, { appId }) {
      axiosInstance.get(`${RoutesAPI.GET_ALL_APPS}/${appId}/${RoutesAPI.LAWS_PATH}`)
        .then((response) => {
          commit('editAll', response.data);
        })
        .catch(handlerError);
    },

    async getEntityTypes({ commit }, { appId }) {
      axiosInstance.get(`${RoutesAPI.GET_ALL_APPS}/${appId}/${RoutesAPI.ENTITY_TYPES_PATH}`)
        .then((response) => {
          commit('editAllEntityTypes', response.data);
        })
        .catch(handlerError);
    },

    async create({ commit }, { appId, body }) {
      return axiosInstance.post(`${RoutesAPI.GET_ALL_APPS}/${appId}/${RoutesAPI.LAWS_PATH}`, body)
        .then((response) => {
          if (response.data.error) {
            return handlerError(response.data.error);
          }
          commit('add', response.data);
          return response.data;
        })
        .catch(handlerError);
    },

    async update({ commit }, { appId, lawId, body }) {
      axiosInstance.put(`${RoutesAPI.GET_ALL_APPS}/${appId}/${RoutesAPI.LAWS_PATH}/${lawId}`, body)
        .then((response) => {
          if (response.data.error) {
            handlerError(response.data.error);
          } else {
            commit('update', response.data);
          }
        })
        .catch(handlerError);
    },

    async delete({ commit }, { appId, lawId }) {
      axiosInstance.delete(`${RoutesAPI.GET_ALL_APPS}/${appId}/${RoutesAPI.LAWS_PATH}/${lawId}`)
        .then((response) => {
          if (response.data.error) {
            handlerError(response.data.error);
          } else {
            commit('delete', lawId);
          }
        })
        .catch(handlerError);
    },
  },
  getters: { },
};
